import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

const STATUSES = ["pending", "paid", "shipped", "completed", "cancelled"];

function StatusSelect({ value, onChange }) {
    return (
        <select value={value} onChange={(e) => onChange(e.target.value)}
            className="bg-surface border border-gold/20 rounded-full px-3 py-1 text-xs text-cream focus:outline-none focus:ring-1 focus:ring-gold">
            {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
    );
}

export default function AdminOrders() {
    const [orders, setOrders] = useState([]);
    const [bookings, setBookings] = useState([]);

    const load = () => {
        api.get("/admin/orders").then((r) => setOrders(r.data));
        api.get("/admin/bookings").then((r) => setBookings(r.data));
    };
    useEffect(() => { load(); }, []);

    const setOrderStatus = async (id, status) => { await api.put(`/admin/orders/${id}/status?status=${status}`); toast.success("Updated"); load(); };
    const setBookingStatus = async (id, status) => { await api.put(`/admin/bookings/${id}/status?status=${status}`); toast.success("Updated"); load(); };

    return (
        <div>
            <h1 className="font-serif text-4xl text-cream mb-6">Orders &amp; Bookings</h1>
            <Tabs defaultValue="orders">
                <TabsList className="bg-surface2 border border-gold/15">
                    <TabsTrigger value="orders" className="data-[state=active]:bg-gold data-[state=active]:text-ink">Orders ({orders.length})</TabsTrigger>
                    <TabsTrigger value="bookings" className="data-[state=active]:bg-gold data-[state=active]:text-ink">Bookings ({bookings.length})</TabsTrigger>
                </TabsList>

                <TabsContent value="orders" className="mt-6 space-y-3" data-testid="admin-orders">
                    {orders.map((o) => (
                        <div key={o.id} className="p-4 rounded-xl bg-surface border border-gold/10 flex items-center justify-between gap-4">
                            <div>
                                <div className="text-cream text-sm">{o.name} · {o.email}</div>
                                <div className="text-xs text-faded">{(o.items || []).map((i) => `${i.quantity}× ${i.name}`).join(", ")}</div>
                                <div className="text-xs text-faded">{new Date(o.created_at).toLocaleString()}</div>
                            </div>
                            <div className="text-right flex items-center gap-4">
                                <span className="text-gold">${o.total.toFixed(2)}</span>
                                <StatusSelect value={o.status} onChange={(s) => setOrderStatus(o.id, s)} />
                            </div>
                        </div>
                    ))}
                    {orders.length === 0 && <p className="text-ash">No orders yet.</p>}
                </TabsContent>

                <TabsContent value="bookings" className="mt-6 space-y-3" data-testid="admin-bookings">
                    {bookings.map((b) => (
                        <div key={b.id} className="p-4 rounded-xl bg-surface border border-gold/10 flex items-center justify-between gap-4">
                            <div>
                                <div className="text-cream text-sm">{b.service_name} <span className="text-faded">({b.booking_type})</span></div>
                                <div className="text-xs text-faded">{b.name} · {b.email}{b.preferred_date && ` · ${b.preferred_date}`}</div>
                                {b.details && <div className="text-xs text-ash mt-1 max-w-lg">{b.details}</div>}
                            </div>
                            <div className="text-right flex items-center gap-4">
                                <span className="text-gold">${b.price.toFixed(2)}</span>
                                <StatusSelect value={b.status} onChange={(s) => setBookingStatus(b.id, s)} />
                            </div>
                        </div>
                    ))}
                    {bookings.length === 0 && <p className="text-ash">No bookings yet.</p>}
                </TabsContent>
            </Tabs>
        </div>
    );
}
